module.exports = __webpack_public_path__ + "files/82bc15bce42053b032cdeda874c9484c.png";